import { useEffect, useState } from 'react';
import { MapContainer } from '@/components/Map/MapContainer';
import { Sidebar } from '@/components/Layout/Sidebar';
import { Toolbar } from '@/components/Layout/Toolbar';
import { StatusBar } from '@/components/Layout/StatusBar';
import { CommandPalette } from '@/components/CommandPalette';
import { YjsProvider } from '@/lib/yjs/provider';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useCollaborationStore } from '@/stores/collaborationStore';

function generateAnonId() {
  return 'anon-' + Math.random().toString(36).slice(2, 10);
}

const ANON_COLORS = [
  '#E57373', '#F06292', '#BA68C8', '#9575CD',
  '#7986CB', '#64B5F6', '#4FC3F7', '#4DD0E1',
  '#4DB6AC', '#81C784', '#AED581', '#DCE775',
];

const ANON_ADJECTIVES = ['Swift', 'Bold', 'Calm', 'Dark', 'Echo', 'Frost', 'Ghost', 'Hawk', 'Iron', 'Jade'];
const ANON_NOUNS = ['Fox', 'Wolf', 'Bear', 'Eagle', 'Raven', 'Tiger', 'Lynx', 'Otter', 'Falcon', 'Cobra'];

function generateAnonName() {
  const adj = ANON_ADJECTIVES[Math.floor(Math.random() * ANON_ADJECTIVES.length)];
  const noun = ANON_NOUNS[Math.floor(Math.random() * ANON_NOUNS.length)];
  return `${adj} ${noun}`;
}

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const connectionStatus = useCollaborationStore((state) => state.connectionStatus);

  // Connect to collaboration room immediately with anonymous identity
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const room = params.get('room') || 'default-operation';

    useCollaborationStore.getState().connect(room, {
      id: generateAnonId(),
      name: generateAnonName(),
      color: ANON_COLORS[Math.floor(Math.random() * ANON_COLORS.length)],
    });

    return () => {
      useCollaborationStore.getState().disconnect();
    };
  }, []);

  return (
    <TooltipProvider>
      <YjsProvider>
        <div className="h-screen w-screen flex flex-col overflow-hidden bg-background">
          <Toolbar />
          <div className="flex-1 flex overflow-hidden">
            <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(!isSidebarOpen)} />
            <main className="flex-1 relative">
              <MapContainer />
            </main>
          </div>
          <StatusBar connectionStatus={connectionStatus} />
          <CommandPalette />
        </div>
      </YjsProvider>
    </TooltipProvider>
  );
}

export default App;
